import React from 'react';
import Select from 'react-select';
import Capsule from '../../common/components/Capsule';
import produce from "immer";
import useTranslation from "../../i18n/useTranslation";

export default function Transfer(props) {
   const { t } = useTranslation();
  const { data, handleDestroy, allTasks, handleChange, allUsers, initData } = props;

  const handleTaskSelect = selectedTask => {
    const nextData = produce(data, draft => {
      draft.typ = selectedTask.value;
    });
    handleChange(nextData, true);
  }

  const transferNames = () => {
    return initData.map(transfer => {
      return { value: transfer.trasaWCId, label: transfer.nazwaTrasy, date: transfer.dataTrasyWC }
    });
  }

  const addUser = user => {
    const nextData = produce(data, draft => {
      draft.uzytkownicy.push(user);
    });
    handleChange(nextData);
  }

  const removeAssignedUser = id => {
    const nextData = produce(data, draft => {
      draft.uzytkownicy = draft.uzytkownicy.filter(user => user.id !== id);
    });
    handleChange(nextData);
  }

  const availableUsers = () => {
    const userIds = data.uzytkownicy.map(user => user.id);
    return allUsers.filter(user => !userIds.includes(user.id));
  }

  const handleInput = (key, value) => {
    const nextData = produce(data, draft => {
      draft.dane[key] = value;
    });
    handleChange(nextData);
  }

  const handleFlightChange = option => {
    const nextData = produce(data, draft => {
      draft.dane.trasaWCId = option.value;
      draft.dane.nazwaTrasy = option.label;
      draft.dane.dataTrasyWC = option.date;
    });
    handleChange(nextData);
  }

  return (
    <div className="margin--bottom">
      <form id={`form-${data.id}`} className="form margin--top form-child">
        <span onClick={() => handleDestroy(data.id)} className="icon icon-close_icon"></span>
        <Select
          value={allTasks.find(option => option.value === data.typ)}
          options={allTasks}
          placeholder={t("taskForms.selectTask")}
          onChange={handleTaskSelect}
          isClearable={false}
        />
        <div className="margin--top row">
          <div className="col-12">
            <Select
              value={data.dane.trasaWCId && { label: data.dane.nazwaTrasy }}
              options={transferNames()}
              placeholder={t("taskForms.selectRoute")}
              onChange={handleFlightChange}
              isClearable={false}
            />
          </div>
        </div>
        <div className="margin--top" style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
          <span className="margin--bottom">{t("taskForms.assigned")}</span>
          {data.uzytkownicy.map(user => <Capsule key={user.id} className="margin--left margin--bottom" id={user.id} text={user.imieNazwisko} onRemove={removeAssignedUser} />)}
          <Select
            options={availableUsers()}
            value={null}
            className="margin--left margin--bottom col-4 padding--remove"
            placeholder={t("taskForms.addPerson")}
            onChange={addUser}
          />
        </div>
        <div>
          <textarea id="uwagi" rows={5} value={data.dane.uwagi} placeholder={t("taskForms.notes")} onChange={ev => handleInput(ev.target.id, ev.target.value)} />
        </div>
      </form>
    </div>
  );
}
